import { render, staticRenderFns } from "./PricesTableComponent.vue?vue&type=template&id=12107d1d"
import script from "./PricesTableComponent.vue?vue&type=script&lang=js"
export * from "./PricesTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports